// src/lib/constants/featureFlags.ts

// Build-time feature flags (ADR-003 §1). Vite statically replaces import.meta.env.*
// at build; absent vars are undefined, so all flags default to false (production
// posture). Gating = conditional route registration + nav gating + flag-gated
// home redirect; non-exposure is the requirement, not bundle exclusion.
export const FEATURE_FLAGS = {
  analyticsEnabled: import.meta.env.VITE_ANALYTICS_ENABLED === 'true',
  legacyReportsEnabled: import.meta.env.VITE_LEGACY_REPORTS_ENABLED === 'true',
  // Delivery ("CDN Delivery") view inside /analytics — staged dark at launch,
  // flipped on post-parity (ADR-010 §3). Subordinate to analyticsEnabled: the
  // whole section is unreachable without that flag.
  analyticsDeliveryEnabled: import.meta.env.VITE_ANALYTICS_DELIVERY_ENABLED === 'true',
  // Analytics metrics expansion (per-media peaks + retention, new-vs-returning
  // viewer mix, embed-domain audience dimension) — ships dark. No new tabs or
  // routes: gating is purely in-component rendering + dimension-group
  // visibility. Subordinate to analyticsEnabled.
  analyticsExpansionEnabled: import.meta.env.VITE_ANALYTICS_EXPANSION_ENABLED === 'true',
  // Live automated captions (AI live captioning) — ships dark. The flag is the
  // launch switch; per-customer visibility additionally requires the
  // allowAutomatedCaptions entitlement (useCaptionsEligibility).
  captionsEnabled: import.meta.env.VITE_CAPTIONS_ENABLED === 'true',
} as const;
